export const PAGINATION_ITEM_TYPE = {
  endEllipsis: 'end-ellipsis',
  next: 'next',
  page: 'page',
  previous: 'previous',
  startEllipsis: 'start-ellipsis',
}
